var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75386 0.246142C9.42566 -0.0820565 8.89357 -0.0820383 8.56539 0.246142L5 3.81154L1.43461 0.246142C1.10641 -0.0820565 0.574323 -0.0820383 0.246142 0.246142C-0.0820383 0.574323 -0.0820565 1.10641 0.246142 1.43461L3.81154 5L0.246142 8.56539C-0.0820383 8.89357 -0.0820565 9.42566 0.246142 9.75386C0.574341 10.0821 1.10643 10.082 1.43461 9.75386L5 6.18846L8.56539 9.75386C8.89359 10.0821 9.42568 10.082 9.75386 9.75386C10.082 9.42568 10.0821 8.89359 9.75386 8.56539L6.18846 5L9.75386 1.43461C10.082 1.10643 10.0821 0.574341 9.75386 0.246142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.cb7c831ec3172bce6b0074de7bfbaa14.svg";
export { ForwardRef as ReactComponent };